import appGlobalScript from '/home/runner/work/website/website/src/global/app.ts';
export const globalScripts = appGlobalScript;
export const globalStyles = "body{margin:0px;padding:0px;font-family:-apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'}";
